<template>
  <div class="device-track-container">
    <BMap ref="bmap" @loaded="bmapLoaded" />

    <div class="data-panel-layer">
      <SensorData v-if="sensors.length" />
      <AlarmTable />
    </div>
  </div>
</template>

<script>
import BMap from '../components/BMapGL';
import AlarmTable from '../components/AlarmTable';
import SensorData from '../components/SensorData';

import monitorMixin from '@/mixins/monitorMixin';

import ctt from '@/utils/const/index';
import { isEmpty } from '@/utils/is';
import { formatTime } from '@/utils/date';

import { toBmapPos } from '@/utils/bmapUtil';

import { View, LineRainbowLayer } from 'mapvgl';

export default {
  mixins: [monitorMixin],
  components: {
    BMap,
    AlarmTable,
    SensorData
  },
  provide() {
    return {
      getSensors: () => {
        return this.sensors;
      },
      getAlarmList: () => {
        return this.alarmList;
      }
    };
  },
  sockets: {
    /** @param {MqttAlarmMessage} res */
    '/socket/alarm'(res) {
      if (res.code === ctt.WS_DANGE1 || res.code === ctt.WS_DANGE2) {
        const { beginTime, message } = res.eventData;

        this.alarmList.push({
          content: message,
          beginTime: formatTime(beginTime)
        });
      }
    }
  },
  data() {
    return {
      beginIconLayer: null,
      bmapRef: null,
      lineLayer: null,
      view: null,
      heatGridLayer: null,
      modMap: {
        [ctt.GD_606]: 'gd606Mod',
        [ctt.GD_612]: 'gd612Mod'
      },
      sensors: [],
      alarmList: [],
      deviceInfoList: [],
      geojson: [
        {
          geometry: {
            type: 'LineString',
            coordinates: []
          }
        }
      ],
      points: [],

      interval: null,
      pause: 2000,
      colors: []
    };
  },
  methods: {
    addGeojson(data) {
      const line = this.geojson[0].geometry.coordinates;

      const coord = [data.longitude, data.latitude];

      line.push(coord);

      this.colors.push(data.state === 0 ? '#3faf7c' : '#ff4500');

      this.lineLayer.setData(this.geojson);

      this.addBeginIcon(coord);
    },
    updateData(data) {
      const { deviceType, modMap } = this;

      const mod = data.mods[modMap[deviceType]];

      if (isEmpty(mod)) return;

      this.sensors = mod.sensors;

      this.deviceInfoList.push(data);

      if (+data.longitude === 0 && +data.latitude === 0) return;

      const coordinate = [+data.longitude, +data.latitude];

      toBmapPos({ coordinate }).then(pos => {
        // this.addPoint(pos[0], pos[1], data.state === 0 ? 50 : 80);

        this.addGeojson({ ...data, longitude: pos[0], latitude: pos[1] });
      });
    },
    bmapLoaded(bmapRef) {
      this.bmapRef = bmapRef;

      this.initLineLayer();

      this.view = new View({
        map: this.bmapRef.bmap
      });

      this.view.addLayer(this.lineLayer);

      // const data = {
      //   features: [
      //     {
      //       type: 'Feature',
      //       properties: { state: '2' },
      //       geometry: {
      //         type: 'LineString',
      //         coordinates: [
      //           [116.41389099999994, 39.914880077046746],
      //           [116.41389099999994, 39.914880077046746]
      //           // [116.70327399999992, 39.54870409944071]
      //         ]
      //       }
      //     },
      //     {
      //       type: 'Feature',
      //       properties: { state: '0' },
      //       geometry: {
      //         type: 'LineString',
      //         coordinates: [
      //           [118.414, 40.915],
      //           [116.70327399999992, 39.54870409944071]
      //         ]
      //       }
      //     },
      //     {
      //       type: 'Feature',
      //       properties: { state: '1' },
      //       geometry: {
      //         type: 'LineString',
      //         coordinates: [
      //           [115.41389099999994, 38.914880077046746],
      //           [116.70327399999992, 39.54870409944071]
      //         ]
      //       }
      //     }
      //   ],
      //   type: 'FeatureCollection'
      // };

      // this.lineLayer.setData(data);
    },
    registeBmapClick() {
      this.bmapRef.bmap.addEventListener('click', e => {
        this.addGeojson(
          {
            longitude: e.latlng.lng,
            latitude: e.latlng.lat,
            state: Math.floor(Math.random() * 3)
          },
          0
        );
      });

      // this.bmapRef.bmap.addEventListener('click', e => {
      //   console.log(this.points);
      //   this.addPoint(e.latlng.lng, e.latlng.lat, 100);
      // });
    },
    initLineLayer() {
      this.lineLayer = new LineRainbowLayer({
        style: 'road', // road, arrow, normal
        width: 12,
        color: this.colors
      });
    },
    removeBeginIcon() {
      console.log(this);
    },
    addBeginIcon(coord) {
      if (this.beginIconLayer) return;

      this.bmapRef.locateTo({ center: coord, zoom: 19 });

      function createDOM() {
        var div = document.createElement('div');
        div.innerText = this.properties.text;
        div.setAttribute(
          'style',
          ` width: 26px;
            height: 26px;
            background: #f00;
            color: #fff;
            border-radius: 50%;
            overflow: hidden;
            box-sizing: border-box;
            font-size: 14px;
            text-align: center;
            line-height: 26px;
            box-shadow: 0 0 2px 2px #fff;`
        );

        return div;
      }

      // 创建自定义覆盖物
      this.beginIconLayer = new BMapGL.CustomOverlay(createDOM, {
        point: new BMapGL.Point(...coord),
        opacity: 0.5,
        offsetY: -10,
        properties: { text: '始' }
      });

      this.bmapRef.bmap.addOverlay(this.beginIconLayer);
    }
  }
};
</script>

<style lang="scss">
.device-track-container {
  position: relative;

  width: 100%;
  height: 100%;

  .data-panel-layer {
    position: absolute;
    right: 0;
    bottom: 0;
    z-index: 9;

    display: flex;
    flex-direction: column;
    gap: 10px;

    width: 428px;

    padding: 10px;

    .el-table {
      border: unset !important;

      &.el-table--border::after {
        width: 0 !important;
      }

      &::before {
        height: 0 !important;
      }

      th:nth-last-of-type(2),
      td:last-of-type {
        border-right: unset !important;
      }
    }
  }
}
</style>
